module.exports = __webpack_public_path__ + "media/images/lp-bar-5d4f32451aa49a264c30914120c08a37.svg";